<template>

  <v-footer app flat style="
        bottom: -50px;
        position: fixed;
        height: 25px;
        width: 100%;
        right: 0px;
        bottom: 0px;
        background-color: #fee7b5;
      ">
    <div class="d-flex justify-space-between" style="width: 100%; font-size: 12px; font-family: Inter; letter-spacing: 0.19px">
      <div style="color: #f27c00">
        <strong>
          <v-icon small color="#F27C00">mdi-clock-outline</v-icon></strong>

        <span> {{ second }}</span>
      </div>
      <div style="color: #f27c00">
        <span>Ambiente:</span>

        <strong>{{ ambiente }}</strong>
      </div>
    </div>
  </v-footer>
</template>
<script>
import { isTokenExpiringSoon } from '../../store/modules/storage'

const IDLE_WARNING_SECONDS = 5 * 60  // avisa 5 min antes de deslogar
const TOKEN_REFRESH_CHECK_INTERVAL = 60 * 1000 // verifica token a cada 1 min
const TOKEN_REFRESH_THRESHOLD_MIN = 10 // renova se faltar ≤ 10 min para expirar

export default {
  data: () => ({
    empresa: "",
    time: 0,
    second: 0,
    nome: "",
    type: null,
    degrade: "degrade",
    items_menu: [],
    _sessionTimerId: null,
    _refreshTimerId: null,
    _idleWarningShown: false,
  }),

  computed: {
    // Ambiente informado pela API (AMBIENTE no .env do servidor). Antes era "Teste" fixo no código,
    // mesmo apontando para a API de produção.
    ambiente() {
      const u = this.$store.state.auth.user
      return (u && u.ambiente) || 'não informado'
    },
  },

  created() {
    this.items = this.$store.state.auth.user && this.$store.state.auth.user.menu
      ? this.$store.state.auth.user.menu
      : []

    this.degrade = "degrade_stone"

    this._startSessionTimer()
    this._startRefreshTimer()
  },

  beforeDestroy() {
    clearInterval(this._sessionTimerId)
    clearInterval(this._refreshTimerId)
  },

  methods: {
    _startSessionTimer() {
      this._sessionTimerId = setInterval(() => {
        this.time += 1000

        const date = new Date(null)
        date.setSeconds(this.time / 1000)
        this.second = date.toISOString().substr(11, 8)

        if (this.$store.state.idleVue && this.$store.state.idleVue.isIdle && !this._idleWarningShown) {
          clearInterval(this._sessionTimerId)
          this._showIdleWarning()
        }
      }, 1000)
    },

    _showIdleWarning() {
      this._idleWarningShown = true
      let countdown = IDLE_WARNING_SECONDS

      this.$swal({
        title: 'Sessão inativa',
        html: `Você está inativo. O logout ocorrerá em <strong>${countdown}</strong> segundos.<br>Clique em continuar para permanecer conectado.`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Continuar',
        allowOutsideClick: false,
        timer: IDLE_WARNING_SECONDS * 1000,
        timerProgressBar: true,
        didOpen: (popup) => {
          const content = popup.querySelector('strong')
          const interval = setInterval(() => {
            countdown--
            if (content) content.textContent = countdown
          }, 1000)
          popup._countdownInterval = interval
        },
        willClose: (popup) => {
          clearInterval(popup._countdownInterval)
        },
      }).then((result) => {
        this._idleWarningShown = false
        if (result.isConfirmed) {
          // Usuário clicou em continuar — reinicia o timer de sessão
          this.time = 0
          this._startSessionTimer()
        } else {
          // Timer esgotou — desloga
          this._signOut()
        }
      })
    },

    _startRefreshTimer() {
      this._refreshTimerId = setInterval(() => {
        if (isTokenExpiringSoon(TOKEN_REFRESH_THRESHOLD_MIN)) {
          this.$store.dispatch('auth/ActionRefreshToken').catch(() => {
            // Refresh falhou — interceptor cuida do logout
          })
        }
      }, TOKEN_REFRESH_CHECK_INTERVAL)
    },

    _signOut() {
      clearInterval(this._sessionTimerId)
      clearInterval(this._refreshTimerId)
      this.$store.dispatch('auth/ActionSignOut')
      this.$router.push({ name: 'login' })
    },
  },
}
</script>
